// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Employee } from './employee';
import { Lodgement } from './lodgement';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EmployeeClaim extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  employeeClaimId!: number;
  createdBy!: string;
  createdDate!: Date;
  deductions!: number;
  empPrefClaim!: number;
  empUnsecClaim!: number;
  employeeClaimTypeLookupId!: number;
  employeeId!: number;
  erani!: number;
  eraprefClaim!: number;
  eratax!: number;
  eraunsecClaim!: number;
  fromDate?: Date;
  isFinalised!: boolean;
  isManualCalc!: boolean;
  isManualClaim!: boolean;
  isNi!: boolean;
  isTaxable!: boolean;
  lodgementId?: number;
  memo?: string;
  ni!: number;
  notionalTax!: number;
  period?: number;
  periodType?: string;
  rate!: number;
  tax!: number;
  toDate?: Date;
  totalClaim!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  employee!: Employee;
  lodgement!: Lodgement;
}

